// extracted by mini-css-extract-plugin
export var content = "BlogPost-module--content--e40ce";
export var img = "BlogPost-module--img--4374d";
export var imgWrapper = "BlogPost-module--imgWrapper--0ad66";
export var link = "BlogPost-module--link--149af";
export var title = "BlogPost-module--title--552fa";
export var titleDesktop = "BlogPost-module--titleDesktop--728e7";
export var titleMobile = "BlogPost-module--titleMobile--50df9";